import { taskClient } from '../services/task-client';

export function reOpenTask(taskId, data = {}) {
  return taskClient().patch(`${process.env.REACT_APP_TASKS_URL}/${taskId}`, data);
}
